export const isEmpty = function fn(val) {
  if (val === null) return true;
  if (typeof val === 'object') return Object.values(val).every((nested) => fn(nested));
  if (Array.isArray(val)) return val.length === 0;
  return !val;
};
